import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CityInfo } from 'src/app/shared/models/domain/cityInfo';
import { ScreenUtils } from 'src/app/utils/screen.utils';
@Component({
  selector: 'reasons-to-buy-banner',
  templateUrl: './reasons-to-buy-banner.component.html',
  styleUrls: ['./reasons-to-buy-banner.component.scss']
})
export class ReasonsToBuyBannerComponent implements OnInit {
  isMobile: boolean = ScreenUtils.isMobile();
  isDesktop: boolean = ScreenUtils.isDesktop();

  firstColumnText: string;

  @Input() destinationCity: CityInfo;

  // destination city code with custom text
  ccWithCustomText = ['CUN'];

  constructor(
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.firstColumnText = this.destinationCity && this.ccWithCustomText.includes(this.destinationCity.code.toUpperCase()) ?
      this.translateService.instant('reasons-to-buy-banner.moveEasilyThroughDestination', {destinationCity: this.destinationCity.text}) :
      this.translateService.instant('reasons-to-buy-banner.moveEasilyThroughDestination.generic');
  }

}
